export default function ({ $config, res }) {
  if (process.server) {
    // https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Access-Control-Allow-Origin
    res.setHeader('Access-Control-Allow-Origin', $config.cmsSiteUrl)
    res.setHeader('Access-Control-Allow-Credentials', 'true')
    // https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Referrer-Policy
    res.setHeader('Referrer-Policy', 'strict-origin-when-cross-origin')
  }
}
